/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/Content/Form/SendNextAppointmentReminder/Content",
  onChange
  
}) {
let newEmailAppointmentRemindersValueData = fromData.useDataValue({ viewPath,
context: 'new_email',
path: 'appointment_reminders',
})
let newEmailSendNextAppointmentReminderValueData = fromData.useDataValue({ viewPath,
context: 'new_email',
path: 'send_next_appointment_reminder',
})
let newEmailSendNextAppointmentReminderChangeData = fromData.useDataChange({ viewPath,
context: 'new_email',
path: 'send_next_appointment_reminder',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="new_email.appointment_reminders"
 disabled={!newEmailAppointmentRemindersValueData}
 data="new_email.send_next_appointment_reminder"
 value={newEmailSendNextAppointmentReminderValueData}
 onChange={newEmailSendNextAppointmentReminderChangeData}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Send next appointment reminder"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}